<div class="ui-feedback" [ngClass]="{ success: feedback === 'success' }">
  <div class="ui-feedback-row" [ngClass]="{ center: !actionDescription }">
    <span [class]="getIcon()"></span>
    <div>
      <div *ngIf="title?.length" class="title">{{ title }}</div>
      <p [innerHTML]="description"></p>
    </div>
  </div>
  <div *ngIf="actionDescription?.length" class="ui-feedback-row checkbox">
    <app-ui-checkbox [ngModel]="checkboxStatus" (ngModelChange)="emitChangeCheckbox($event)"
      ><span [innerHTML]="actionDescription"></span
    ></app-ui-checkbox>
  </div>
</div>
